// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const APP_INFO = {
    "version": "0.0.1",
    "sha": "01f82af93b7abed253829c2fdaef467ab8ecf4d5",
    "authorDate": null
};
/* tslint:enable */
